export var Symbology;
(function (Symbology) {
    Symbology["A"] = "upc-a_upc-e_upc-e1_ean-1_ean_13";
    Symbology["B"] = "code-39_code-32";
    Symbology["C"] = "codabar";
    Symbology["D"] = "code-128_isbt-128_isbt-128-concat";
    Symbology["E"] = "code-93";
    Symbology["F"] = "interleaved-2-of-5";
    Symbology["G"] = "discrete-2-of-5";
    Symbology["H"] = "code-11";
    Symbology["J"] = "msi";
    Symbology["K"] = "gs1-128";
    Symbology["L"] = "bookland-ean";
    Symbology["M"] = "trioptic-code-39";
    Symbology["N"] = "coupon-code";
    Symbology["R"] = "gs1-databar-family";
    Symbology["S"] = "matrix-2-of-5";
    Symbology["T"] = "ucc-composite_tlc-39";
    Symbology["U"] = "chinese-2-of-5";
    Symbology["V"] = "korean-3-of-5";
    Symbology["X"] = "issn-ean_pdf-417_marco-pdf-417_micro-pdf-417";
    Symbology["z"] = "aztec_aztec-rune";
    Symbology["P00"] = "data-matrix";
    Symbology["P01"] = "qr-code_micro-qr";
    Symbology["P02"] = "maxicode";
    Symbology["P03"] = "us-postnet";
    Symbology["P04"] = "us-planet";
    Symbology["P05"] = "japan-postal";
    Symbology["P06"] = "uk-postal";
    Symbology["P08"] = "netherlands_kix_code";
    Symbology["P09"] = "australia_post";
    Symbology["P0A"] = "usps-4cb_one-code_intelligant-mail";
    Symbology["P0B"] = "upu_fics_postal";
    Symbology["P0C"] = "mailmark";
    Symbology["P0G"] = "gs1-data-matrix";
    Symbology["P0H"] = "han-xin";
    Symbology["P0Q"] = "gs1-qr";
    Symbology["P0X"] = "signature-capture";
})(Symbology || (Symbology = {}));
export function symbolCodeSymbology(barcode) {
    if (!barcode) {
        return null;
    }
    const retObj = {
        barcode: null,
        symbology: null,
        symbolCodeIDChar: null,
    };
    let countCodeChars = 1;
    if (barcode.substring(0, 1) === 'P') {
        countCodeChars = 3;
    }
    const symbologyChar = barcode.substring(0, countCodeChars);
    const symbology = Symbology[symbologyChar];
    if (symbology !== undefined) {
        retObj.symbology = symbology;
        retObj.symbolCodeIDChar = symbologyChar;
        retObj.barcode = barcode.substring(countCodeChars);
    }
    return retObj;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3ltYm9sb2dpZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL1N5bWJvbG9naWVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLFNBcUNYO0FBckNELFdBQVksU0FBUztJQUNuQixrREFBdUMsQ0FBQTtJQUN2QyxrQ0FBdUIsQ0FBQTtJQUN2QiwwQkFBZSxDQUFBO0lBQ2Ysb0RBQXlDLENBQUE7SUFDekMsMEJBQWUsQ0FBQTtJQUNmLHFDQUEwQixDQUFBO0lBQzFCLGtDQUF1QixDQUFBO0lBQ3ZCLDBCQUFlLENBQUE7SUFDZixzQkFBVyxDQUFBO0lBQ1gsMEJBQWUsQ0FBQTtJQUNmLCtCQUFvQixDQUFBO0lBQ3BCLG1DQUF3QixDQUFBO0lBQ3hCLDhCQUFtQixDQUFBO0lBQ25CLHFDQUEwQixDQUFBO0lBQzFCLGdDQUFxQixDQUFBO0lBQ3JCLHVDQUE0QixDQUFBO0lBQzVCLGlDQUFzQixDQUFBO0lBQ3RCLGdDQUFxQixDQUFBO0lBQ3JCLCtEQUFvRCxDQUFBO0lBQ3BELG1DQUF3QixDQUFBO0lBQ3hCLGdDQUFxQixDQUFBO0lBQ3JCLHFDQUEwQixDQUFBO0lBQzFCLDZCQUFrQixDQUFBO0lBQ2xCLCtCQUFvQixDQUFBO0lBQ3BCLDhCQUFtQixDQUFBO0lBQ25CLGlDQUFzQixDQUFBO0lBQ3RCLDhCQUFtQixDQUFBO0lBQ25CLHlDQUE4QixDQUFBO0lBQzlCLG1DQUF3QixDQUFBO0lBQ3hCLHVEQUE0QyxDQUFBO0lBQzVDLG9DQUF5QixDQUFBO0lBQ3pCLDZCQUFrQixDQUFBO0lBQ2xCLG9DQUF5QixDQUFBO0lBQ3pCLDRCQUFpQixDQUFBO0lBQ2pCLDJCQUFnQixDQUFBO0lBQ2hCLHNDQUEyQixDQUFBO0FBQzdCLENBQUMsRUFyQ1csU0FBUyxLQUFULFNBQVMsUUFxQ3BCO0FBU0QsTUFBTSxVQUFVLG1CQUFtQixDQUFDLE9BQWU7SUFDakQsSUFBSSxDQUFDLE9BQU8sRUFBRTtRQUNaLE9BQU8sSUFBSSxDQUFDO0tBQ2I7SUFFRCxNQUFNLE1BQU0sR0FBRztRQUNiLE9BQU8sRUFBRSxJQUFJO1FBQ2IsU0FBUyxFQUFFLElBQUk7UUFDZixnQkFBZ0IsRUFBRSxJQUFJO0tBQ3ZCLENBQUM7SUFDRixJQUFJLGNBQWMsR0FBRyxDQUFDLENBQUM7SUFDdkIsSUFBSSxPQUFPLENBQUMsU0FBUyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsS0FBSyxHQUFHLEVBQUU7UUFDbkMsY0FBYyxHQUFHLENBQUMsQ0FBQztLQUNwQjtJQUVELE1BQU0sYUFBYSxHQUFHLE9BQU8sQ0FBQyxTQUFTLENBQUMsQ0FBQyxFQUFFLGNBQWMsQ0FBQyxDQUFDO0lBRTNELE1BQU0sU0FBUyxHQUFHLFNBQVMsQ0FBQyxhQUFhLENBQUMsQ0FBQztJQUUzQyxJQUFJLFNBQVMsS0FBSyxTQUFTLEVBQUU7UUFDM0IsTUFBTSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUM7UUFDN0IsTUFBTSxDQUFDLGdCQUFnQixHQUFHLGFBQWEsQ0FBQztRQUN4QyxNQUFNLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQyxTQUFTLENBQUMsY0FBYyxDQUFDLENBQUM7S0FDcEQ7SUFFRCxPQUFPLE1BQU0sQ0FBQztBQUNoQixDQUFDIn0=